<template>
  <div class="playing-tv">
    <div class="playing-tv__header">
      <div class="playing-tv__title-wrapper">
        <div class="playing-tv__title">Now Playing TV Shows</div>
        <a class="playing-tv__more" :href="moreUrl">
          <div class="playing-tv__more-text">More</div>
          <div class="playing-tv__more-icon">
            <img class="playing-tv__more-arrow" src="@/assets/icon/arrow_right_alt.svg" />
          </div>
        </a>
      </div>
      <div class="playing-tv__controls" v-if="deviceType !== 'mobile'">
        <div class="playing-tv__control playing-tv__control--prev"
          :class="{ 'playing-tv__control--disabled': !hasPrev }" @click="prevSlide">
          <svg xmlns="http://www.w3.org/2000/svg" class="playing-tv__control-arrow" width="6"
            height="12" viewBox="0 0 6 12" fill="none">
            <path
              d="M1.56641 6.00382L5.79139 1.35876C5.9351 1.20076 6.00456 1.0138 5.99977 0.797876C5.99498 0.581949 5.92073 0.394988 5.77702 0.236993C5.63332 0.0789977 5.46326 0 5.26686 0C5.07046 0 4.90041 0.0789977 4.7567 0.236993L0.344896 5.10325C0.229931 5.22965 0.143707 5.37184 0.0862241 5.52984C0.0287414 5.68783 0 5.84583 0 6.00382C0 6.16182 0.0287414 6.31981 0.0862241 6.47781C0.143707 6.6358 0.229931 6.778 0.344896 6.9044L4.77107 11.7707C4.91478 11.9286 5.08244 12.005 5.27405 11.9997C5.46566 11.9945 5.63332 11.9128 5.77702 11.7549C5.92073 11.5969 5.99258 11.4099 5.99258 11.194C5.99258 10.978 5.92073 10.7911 5.77702 10.6331L1.56641 6.00382Z"
              fill="white" />
          </svg>
        </div>
        <div class="playing-tv__control playing-tv__control--next"
          :class="{ 'playing-tv__control--disabled': !hasNext }" @click="nextSlide">
          <svg xmlns="http://www.w3.org/2000/svg" class="playing-tv__control-arrow"
            viewBox="0 0 6 12" fill="none">
            <path
              d="M4.43359 6.00382L0.208607 1.35876C0.0649 1.20076 -0.00455845 1.0138 0.000231786 0.797876C0.00502202 0.581949 0.0792707 0.394988 0.222978 0.236993C0.366685 0.0789977 0.536738 0 0.733138 0C0.929537 0 1.09959 0.0789977 1.2433 0.236993L5.6551 5.10325C5.77007 5.22965 5.85629 5.37184 5.91378 5.52984C5.97126 5.68783 6 5.84583 6 6.00382C6 6.16182 5.97126 6.31981 5.91378 6.47781C5.85629 6.6358 5.77007 6.778 5.6551 6.9044L1.22893 11.7707C1.08522 11.9286 0.917562 12.005 0.725952 11.9997C0.534343 11.9945 0.366685 11.9128 0.222978 11.7549C0.0792707 11.5969 0.00741714 11.4099 0.00741714 11.194C0.00741714 10.978 0.0792707 10.7911 0.222978 10.6331L4.43359 6.00382Z"
              fill="white" />
          </svg>
        </div>
      </div>
    </div>
    <div class="playing-tv__content" v-if="shows.length > 0">
      <div class="playing-tv__featured">
        <div class="playing-tv__featured-poster" @click="navigateToDetail(shows[0])">
          <img class="playing-tv__featured-img" :src="shows[0].poster" alt="" />
          <div class="playing-tv__featured-overlay"></div>
          <div class="playing-tv__featured-action-row">
            <div class="playing-tv__featured-action">
              <img class="playing-tv__featured-play" src="@/assets/icon/play-circle.svg" />
              <div class="playing-tv__featured-action-text">Watch Trailer</div>
            </div>
            <div class="playing-tv__featured-dashed"></div>
            <div class="playing-tv__featured-info">
              <div class="playing-tv__featured-title">{{ shows[0].title }}</div>
              <div class="playing-tv__featured-meta">
                <div class="playing-tv__featured-rating">
                  <img class="playing-tv__featured-star" src="@/assets/icon/star.svg" />
                  <div class="playing-tv__featured-score">{{ Number(shows[0].score).toFixed(1) }}
                  </div>
                </div>
                <div class="playing-tv__featured-separator"></div>
                <div class="playing-tv__featured-date">{{ shows[0].date }}</div>
                <div class="playing-tv__featured-separator"></div>
                <div class="playing-tv__featured-genre">{{ shows[0].genre }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- PC端网格布局 -->
      <div v-if="deviceType !== 'mobile'" class="playing-tv__grid" ref="sliderContainer">
        <div v-for="(show, index) in showsForSlider" :key="index" class="playing-tv__card"
          @click="navigateToDetail(show)">
          <div class="playing-tv__card-poster">
            <img class="playing-tv__card-img" :src="show.poster" alt="" />
            <div class="playing-tv__card-overlay"></div>
            <div class="playing-tv__card-info">
              <div class="playing-tv__card-title">{{ show.title }}</div>
              <div class="playing-tv__card-meta">
                <div class="playing-tv__card-rating">
                  <img class="playing-tv__card-star" src="@/assets/icon/star.svg" />
                  <div class="playing-tv__card-score">{{ Number(show.score).toFixed(1) }}</div>
                </div>
                <div class="playing-tv__card-separator"></div>
                <div class="playing-tv__card-date">{{ show.date }}</div>
                <div class="playing-tv__card-separator"></div>
                <div class="playing-tv__card-genre">{{ show.genre }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 移动端滑动布局 -->
      <div v-else class="playing-tv__slider">
        <div class="playing-tv__slider-container" ref="sliderContainer">
          <div v-for="(show, index) in showsForSlider" :key="index" class="playing-tv__card"
            @click="navigateToDetail(show)">
            <div class="playing-tv__card-poster">
              <img class="playing-tv__card-img" :src="show.poster" alt="" />
              <div class="playing-tv__card-overlay"></div>
              <div class="playing-tv__card-info">
                <div class="playing-tv__card-title">{{ show.title }}</div>
                <div class="playing-tv__card-meta">
                  <div class="playing-tv__card-rating">
                    <img class="playing-tv__card-star" src="@/assets/icon/star.svg" />
                    <div class="playing-tv__card-score">{{ Number(show.score).toFixed(1) }}</div>
                  </div>
                  <div class="playing-tv__card-separator"></div>
                  <div class="playing-tv__card-date">{{ show.date }}</div>
                  <div class="playing-tv__card-separator"></div>
                  <div class="playing-tv__card-genre">{{ show.genre }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PlayingTV',
  props: {
    shows: {
      type: Array,
      default: () => []
    },
    moreUrl: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentIndex: 0,
      itemsPerRow: 3,
      rowsPerPage: 2,
      totalItems: 0
    };
  },
  computed: {
    ...mapGetters({
      deviceType: 'deviceType'
    }),
    hasPrev () {
      return this.currentIndex > 0;
    },
    hasNext () {
      return this.currentIndex + (this.itemsPerRow * this.rowsPerPage) < this.totalItems - 1;
    },
    gridShows () {
      // 跳过第一个用作大卡片的节目，获取当前页的所有卡片
      const start = this.currentIndex + 1;
      const itemsToShow = this.itemsPerRow * this.rowsPerPage;
      return this.shows.slice(start, start + itemsToShow);
    },
    showsForSlider () {
      // 从第1个开始，因为第0个已经在featured中显示
      return this.shows.slice(1);
    }
  },
  watch: {
    shows: {
      immediate: true,
      handler (newVal) {
        this.totalItems = newVal.length;
      }
    }
  },
  methods: {
    prevSlide () {
      if (this.hasPrev) {
        this.currentIndex--;
        this.scrollSlider();
      }
    },
    nextSlide () {
      if (this.hasNext) {
        const container = this.$refs.sliderContainer;
        if (container) {
          const cardWidth = container.querySelector('.playing-tv__card').offsetWidth;
          const gapWidth = parseInt(window.getComputedStyle(container).getPropertyValue('gap'));
          const sliderWidth = this.$el.querySelector('.playing-tv__grid').offsetWidth;

          // 如果是最后几个元素，确保显示到最后一个
          if (this.currentIndex + this.visibleItems + 1 >= this.totalItems) {
            // 计算可以显示的最大索引，确保最后一个卡片完全可见
            const maxIndex = this.totalItems - Math.floor(sliderWidth / (cardWidth + gapWidth));
            this.currentIndex = Math.max(0, maxIndex);
          } else {
            this.currentIndex++;
          }
          this.scrollSlider();
        }
      }
    },
    scrollSlider () {
      const container = this.$refs.sliderContainer;
      if (container) {
        const cardWidth = container.querySelector('.playing-tv__card').offsetWidth;
        const gapWidth = parseInt(window.getComputedStyle(container).getPropertyValue('gap'));

        // 获取左侧padding值
        const sliderElement = this.$el.querySelector('.playing-tv__grid');
        const leftPadding = parseInt(window.getComputedStyle(sliderElement).getPropertyValue('padding-left'));

        let translateX = 0;
        if (this.currentIndex === 0) {
          // 第一个位置，不需要偏移
          translateX = 0;
        } else if (this.currentIndex === 1) {
          // 第一次滚动，需要考虑左侧padding
          translateX = leftPadding + cardWidth + gapWidth;
        } else {
          // 后续滚动，考虑第一张卡片和左侧padding，以及后续的卡片和间距 间距是两侧的 所以要加两遍
          translateX = leftPadding + cardWidth + gapWidth + (this.currentIndex - 1) * (cardWidth + gapWidth);
        }

        // container.style.transform = `translateX(-${translateX}px)`;
        container.scrollLeft = translateX;
      }
    },
    navigateToDetail (show) {
      // 格式化电视剧名称为URL友好的格式
      const formattedName = show.name ? show.name.toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]/g, '') : 'tv-show';

      // 准备保存到本地存储的数据
      const showData = {
        id: show.id,
        title: show.name,
        poster: `https://image.filmzillaxtra.com/t/p/w440_and_h660_face/${show.poster_path}`,
        genres: show.genre_ids ? show.genre_ids.map(id => {
          const genre = this.tvGenres.find(g => g.id === id);
          return genre ? genre.name : '';
        }).filter(Boolean) : [],
        score: show.vote_average,
        date: show.first_air_date,
        description: show.overview,
        type: 'tv' // 标记为电视剧类型
      };

      // 保存数据到本地存储
      localStorage.setItem('selectedMovie', JSON.stringify(showData));

      // 跳转到详情页
      this.$router.push(`/tv-shows/${show.id}-${formattedName}/`);
    }
  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.playing-tv {
	display: flex;
	flex-direction: column;
	gap: rem(24);
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	width: 100%;

	&__header {
		padding: 0 rem(16);
		display: flex;
		flex-direction: column;
		gap: rem(16);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		width: 100%;
	}

	&__title-wrapper {
		display: flex;
		flex-direction: column;
		gap: rem(16);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
	}

	&__title {
		color: #ffffff;
		text-align: left;
		font-size: rem(24);
		line-height: rem(24);
		font-weight: 900;
		position: relative;
	}

	&__more {
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		position: relative;
		cursor: pointer;
	}

	&__more-text {
		color: #fe324b;
		text-align: left;
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 400;
		position: relative;
	}

	&__more-icon {
		width: rem(16);
		height: rem(12);
		position: relative;
	}

	&__more-arrow {
		width: 100%;
		overflow: visible;
	}

	&__controls {
		display: flex;
		flex-direction: row;
		gap: rem(20);
		align-items: flex-start;
		justify-content: flex-end;
		position: relative;
	}

	&__control {
		width: rem(28);
		height: rem(28);
		position: relative;
		cursor: pointer;

		&::before {
			content: '';
			background: #ffffff;
			border-radius: 100px;
			opacity: 0.1;
			width: rem(28);
			height: rem(28);
			position: absolute;
			left: 0;
			top: 0;
		}

		&--disabled {
			opacity: 0.5;
			cursor: default;
		}
	}

	&__control-arrow {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: rem(6);
		height: rem(12);
	}

	&__content {
		display: flex;
		flex-direction: column;
		gap: rem(16);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		width: 100%;
	}

	&__featured {
		padding: 0 rem(16);
		display: flex;
		flex-direction: column;
		gap: rem(16);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		padding-top: rem(6);
	}

	&__featured-poster {
		width: 100%;
		height: rem(232);
		position: relative;
		border-radius: rem(16);
		overflow: hidden;
	}

	&__featured-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
	}

	&__featured-overlay {
		background: linear-gradient(180deg, rgba(13, 12, 15, 0) 0%, rgba(13, 12, 15, 0.1) 60%, rgba(13, 12, 15, 0.6) 70%, rgba(13, 12, 15, 1) 90%, rgba(13, 12, 15, 1) 100%);
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
	}

	&__featured-action-row {
		position: absolute;
		left: rem(16);
		bottom: rem(16);
		display: flex;
		gap: rem(16);
		align-content: center;
	}

	&__featured-action {
		background: #fe324b;
		border-radius: 100px;
		padding: rem(12);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	&__featured-play {
		width: rem(20);
		height: rem(20);
	}

	&__featured-action-text {
		display: none;
	}

	&__featured-dashed {
		width: rem(1);
		opacity: 0.1;
		background: #fff;
		height: rem(44);
	}
	&__featured-info {
		display: flex;
		flex-direction: column;
		gap: rem(8);
		align-items: flex-start;
		justify-content: center;
	}

	&__featured-title {
		color: #ffffff;
		text-align: left;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 500;
		position: relative;
		align-self: stretch;
	}

	&__featured-meta {
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;
		overflow: hidden;
	}

	&__featured-rating {
		border-radius: rem(16) 0 rem(16) 0;
		display: flex;
		flex-direction: row;
		gap: rem(8);
		align-items: center;
		justify-content: flex-start;
		position: relative;
	}

	&__featured-star {
		width: rem(12);
		height: rem(12);
	}

	&__featured-score {
		color: #ffaf00;
		text-align: left;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 700;
		text-transform: uppercase;
		position: relative;
	}

	&__featured-separator {
		background: #ffffff;
		opacity: 0.2;
		width: rem(1);
		height: rem(16);
		position: relative;
	}

	&__featured-date {
		color: #ffffff;
		text-align: left;
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		text-transform: uppercase;
		opacity: 0.6;
		position: relative;
	}

	&__featured-genre {
		color: #ffffff;
		text-align: left;
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		opacity: 0.6;
		position: relative;
	}

	&__slider {
		padding: 0 0 0 rem(16);
		overflow-x: auto;
		width: 100%;
		position: relative;

		/* 隐藏滚动条 */
		scrollbar-width: none; /* Firefox */
		-ms-overflow-style: none; /* IE and Edge */
		&::-webkit-scrollbar {
			display: none; /* Chrome, Safari and Opera */
		}
	}

	&__slider-container {
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		padding-right: rem(16);
	}

	&__grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		// grid-template-rows: repeat(2, 1fr);
		padding-top: rem(6);

		grid-template-rows: repeat(2, auto);
		grid-auto-flow: column;
		gap: rem(16);
		align-items: start;
		// justify-content: center;
		position: relative;
		// width: calc(100% - rem(552) - rem(96));
		// margin-right: rem(80);
		overflow: auto;
		grid-auto-flow: column;
		width: 100%;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		scrollbar-width: none;
	}

	&__card {
		// width: 100%;
		width: rem(268);
		height: rem(180);
		position: relative;
		cursor: pointer;
		transition: transform 0.3s ease;

		&:hover {
			transform: translateY(-4px);
		}
	}

	&__card-poster {
		width: 100%;
		height: 100%;
		position: relative;
	}

	&__card-img {
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&__card-overlay {
		background: linear-gradient(180deg, rgba(13, 12, 15, 0) 0%, rgba(13, 12, 15, 0.1) 50%, rgba(13, 12, 15, 0.6) 70%, rgba(13, 12, 15, 1) 90%, rgba(13, 12, 15, 1) 100%);
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
	}

	&__card-info {
		padding: 0 rem(16) rem(16) rem(16);
		display: flex;
		flex-direction: column;
		gap: rem(8);
		align-items: flex-start;
		justify-content: flex-start;
		width: 100%;
		position: absolute;
		left: 0;
		bottom: 0;
	}

	&__card-title {
		color: #ffffff;
		text-align: left;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 500;
		position: relative;
		align-self: stretch;
	}

	&__card-meta {
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;
		overflow: hidden;
	}

	&__card-rating {
		border-radius: rem(16) 0 rem(16) 0;
		display: flex;
		flex-direction: row;
		gap: rem(8);
		align-items: center;
		justify-content: flex-start;
		position: relative;
	}

	&__card-star {
		width: rem(12);
		height: rem(12);
	}

	&__card-score {
		color: #ffaf00;
		text-align: left;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 700;
		text-transform: uppercase;
	}

	&__card-separator {
		background: #ffffff;
		opacity: 0.2;
		width: rem(1);
		height: rem(16);
	}

	&__card-date {
		color: #ffffff;
		text-align: left;
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		text-transform: uppercase;
		opacity: 0.6;
	}

	&__card-genre {
		color: #ffffff;
		text-align: left;
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		opacity: 0.6;
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.playing-tv {
		&__header {
			padding: 0 rem(80);
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
		}

		&__title-wrapper {
			flex-direction: row;
			gap: rem(24);
		}

		&__featured {
			padding: 0 0 0 rem(80);
		}

		&__featured-poster {
			width: rem(552);
			height: rem(372);
		}

		&__featured-action {
			padding: rem(12) rem(16);
			gap: rem(12);
			justify-content: flex-start;
		}

		&__featured-action-text {
			color: #ffffff;
			text-align: left;
			font-size: rem(16);
			line-height: rem(16);
			font-weight: 700;
			position: relative;
			display: block;
		}

		&__featured-info {
			width: rem(268);
		}

		&__content {
			flex-direction: row;
		}

		&__slider {
			padding: 0 0 0 rem(80);

			&-container {
				padding-right: rem(80);
			}
		}

		&__card {
			// width: 100%;
		}
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.playing-tv {
		&__header {
			padding: 0 rem(16);
		}

		&__content {
			flex-direction: column;
			align-items: center;
			gap: rem(16);
		}

		&__featured {
			padding: 0 rem(16);
			width: 100%;
		}

		&__featured-poster {
			width: 100%;
			height: rem(232);
		}

		&__slider {
			width: 100%;
		}

		&__card {
			flex-shrink: 0;
			width: rem(268);
		}
	}
}
</style> 